import CustomPage from './custom-page'
import CustomPageQuery, { CUSTOM_PAGE_QUERY } from './custom-page.query'

export { CustomPageQuery, CUSTOM_PAGE_QUERY }

export default CustomPage
